import { NgModule } from '@angular/core';
import { TrialKitService } from './services';

@NgModule({
  providers: [TrialKitService]
})
export class DomainTrialKitModule {}